import { render, staticRenderFns } from "./addPromotionLabel.vue?vue&type=template&id=241af30c&scoped=true&"
import script from "./addPromotionLabel.vue?vue&type=script&lang=js&"
export * from "./addPromotionLabel.vue?vue&type=script&lang=js&"
import style0 from "./addPromotionLabel.vue?vue&type=style&index=0&id=241af30c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241af30c",
  null
  
)

export default component.exports